import { memo, useCallback } from 'react';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../SVGIcon';

import styles from './ScrollArrows.module.css';

export type ScrollArrowsProps = {
  scrollToTop?: () => void;
  scrollToBottom?: () => void;
};

export const ScrollArrows = memo(
  ({ scrollToTop, scrollToBottom }: ScrollArrowsProps) => {
    const scrollToTopDefault = useCallback(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, []);

    const scrollToBottomDefault = useCallback(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth',
      });
    }, []);
    return (
      <div className={styles.container}>
        <SvgIcon
          name={SVGIconType.ScrollArrow}
          width={50}
          height={50}
          style={{ marginBottom: 20 }}
          onClick={scrollToTop ?? scrollToTopDefault}
          color="#fff"
        />
        <SvgIcon
          name={SVGIconType.ScrollArrow}
          width={50}
          height={50}
          style={{ transform: 'scaleY(-1)' }}
          onClick={scrollToBottom ?? scrollToBottomDefault}
          color="#fff"
        />
      </div>
    );
  },
);
